import React, { useContext, useMemo } from 'react'
import {
  Routes as RouteList,
  Route,
  Navigate
} from "react-router-dom";

//Context
import { GlobalContext } from "contexts";

//Pages
import {
  UploadListing,
  Dashboard,
  Beranda,
  EReporting,
  Login,
  KreditKonsumen,
  ListListing,
  DashboardLeads,
  KeyMetricOfficeDashboard,
  Marketing,
  Invoice,
  LeadsManagement,
  IpafEvent,
  ProgressTrackerRumah123,
  One21Event,
  LeadsDistribution,
  BuyerMatch,
  ListArchivedBuyer,
  ListBuyerMatch,
  SofiaMagicStudio,
  ListListingSofia,
  SofiaTidiedUpPhoto,
  ShowingActivity,
} from "pages";
import { Training } from "pages/dashboard";
import Feed from "pages/dashboard/showing-activity/feed/feed";
import ShowingActivityMarketing from "pages/dashboard/showing-activity/marketing/marketing";

// import InvoiceList from "pages/dashboard/invoice/components/list"
import InvoiceList from "pages/dashboard/invoice/components/list-invoice"
import ListInvoiceTraining from "pages/dashboard/invoice/components/list-training"
import InvoiceDetail from "pages/dashboard/invoice/components/detail"
import PaymentResult from "pages/dashboard/invoice/components/payment-result"

//Auth Route
import AuthRoute from "routes/AuthRoute";
import PrivateDashboardList from "routes/private-routes/PrivateDashboardList"

const Routes = () => {
  const { profile, showInvoice, showIpaf, showOne21Event, showInvoiceAndEreporting, isRoleProjectAdmin } = useContext(GlobalContext);

  const isMB = useMemo(() => {
    return profile?.role?.name === "Member Broker"
  }, [profile])

  const renderRoutes = () => {
    if(isRoleProjectAdmin) return (
      <Route path="/leads-management" element={<LeadsManagement />} />
    );

    return (
      <>
      {showInvoiceAndEreporting && <Route path="/ereporting" element={<EReporting></EReporting>} />}
          <Route path="/" element={<Beranda></Beranda>} />
          <Route path="/listing" element={<ListListing></ListListing>} />
          <Route path="/upload-listing" element={<UploadListing></UploadListing>} />
          <Route path="/upload-listing/:slug" element={<UploadListing></UploadListing>} />
          {/* <Route path="/kredit-konsumen" element={<KreditKonsumen />} /> */}
          <Route path="/leads-my-ciputra" element={<DashboardLeads />} />
          <Route path="/leads-management" element={<LeadsManagement />} />
          <Route path="/showing-activity" element={<ShowingActivity />}>
            <Route path="/showing-activity" element={<Navigate to="/showing-activity/feed" />} />
            <Route path="/showing-activity/feed" element={<Feed />} />
            <Route path="/showing-activity/marketing" element={<ShowingActivityMarketing />} />
          </Route>
          <Route path="/key-metric-office-dashboard" element={<KeyMetricOfficeDashboard />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/progress-tracker" element={<ProgressTrackerRumah123 />} />
          <Route path="/leads-listing" element={<LeadsDistribution />} />
          <Route path="/training" element={<Training />} />
          <Route path="/buyer-match" element={<BuyerMatch />}>
            <Route path="/buyer-match" element={<ListBuyerMatch />} />
            <Route path="/buyer-match/list-archived" element={<ListArchivedBuyer />} />
          </Route>
          <Route path="/sofia-magic-studio" element={<SofiaMagicStudio />}>
            <Route path="/sofia-magic-studio" element={<ListListingSofia />} />
            <Route path="/sofia-magic-studio/tidied-up-photo" element={<SofiaTidiedUpPhoto />} />
          </Route>
          {showIpaf && <Route path="/ipaf-event" element={<IpafEvent />} />}
          {showOne21Event && <Route path="/one21-event" element={<One21Event />} />}
          {showInvoice && showInvoiceAndEreporting && <Route path="/invoice" element={<Invoice />}>
            <Route path="/invoice" element={<InvoiceList />} />
            <Route path="/invoice/training" element={<ListInvoiceTraining />} />
            <Route path="/invoice/payment-result/success" element={<PaymentResult />} />
            <Route path="/invoice/payment-result/failed" element={<PaymentResult />} />
            <Route path="/invoice/:id" element={<InvoiceDetail />} />
            <Route path="*" element={<Navigate to="/invoice" />} />
          </Route>}
      </>
    );
  }

  return (
    <div className='pages-container'>
      <RouteList>
        <Route path="/" element={<AuthRoute><Dashboard /></AuthRoute>}>
          {renderRoutes()}
        </Route>
        <Route path="/login" element={<Login></Login>} />
        <Route
          path="*"
          element={isMB ? <Navigate to="/ereporting" /> : <Navigate to="/" />}
        />
      </RouteList>
    </div>
  )
}

export default Routes;